import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حساب الزيادة في الراتب";
const DESCRIPTION =
  "استخدم حاسبة الزيادة في الراتب لحساب قيمة الزيادة التي ستحصل عليها بناءً على نسبة مئوية معينة من راتبك الأساسي.";
const KEYWORDS =
  "حاسبة الزيادة في الراتب, حساب زيادة الراتب, نسبة الزيادة, الراتب الأساسي, الحاسبة المالية";
const OG_URL =
  "https://do-calculate.com/calculator/ar/salary-bonus-calculator/";
function SalaryBonusCalculator() {
  const [salary, setSalary] = useState("");
  const [percentage, setPercentage] = useState("");
  const [result, setResult] = useState(null);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!salary || !percentage) {
        setError("يرجى إدخال الراتب والنسبة المئوية.");
        return;
      }
      const basicSalary = parseFloat(salary);
      const bonusPercentage = parseFloat(percentage) / 100;
      const bonusAmount = (basicSalary * bonusPercentage).toFixed(2);
      const total = parseInt(basicSalary) + parseInt(bonusAmount);
      const step1 = `الراتب الأساسي: ${basicSalary}`;
      const step2 = `نسبة الزيادة: ${bonusPercentage * 100}%`;
      const step3 = `حساب الزيادة: ${basicSalary} × ${bonusPercentage} = ${bonusAmount}`;
      const step4 = `الراتب بعد الزيادة: ${total}`;
      setSteps([step1, step2, step3, step4]);
      setResult(bonusAmount);
      setError("");
    } catch (err) {
      setError("حدث خطأ أثناء الحساب. يرجى المحاولة مرة أخرى.");
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هل تريد فهم كيفية حساب الزيادة في الراتب؟ هذه الحاسبة توفر لك
                  شرحًا مبسطًا لعملية الحساب. بإدخال راتبك الأساسي والنسبة
                  المئوية للزيادة، ستحصل على النتيجة النهائية، بالإضافة إلى شرح
                  لكيفية تطبيق معادلة النسبة المئوية لحساب الزيادة.
                </p>
                <p>
                  <strong>
                    الزيادة = الراتب الأساسي × (النسبة المئوية ÷ 100)
                  </strong>
                </p>
                <ul>
                  <li>
                    أدخل الراتب الأساسي والنسبة المئوية للزيادة لحساب الزيادة
                    المالية.
                  </li>
                </ul>
                <p>
                  لتحقيق زيادة في الراتب، يتم حساب قيمة الزيادة عن طريق ضرب
                  الراتب الأساسي في النسبة المئوية للزيادة مقسومة على 100. هذه
                  الحاسبة تقوم بهذا الحساب تلقائياً. أدخل راتبك الأساسي والنسبة
                  المئوية للزيادة، وستحصل على قيمة الزيادة الجديدة، بالإضافة إلى
                  شرح مبسط لكيفية تطبيق معادلة النسبة المئوية لحساب الزيادة.
                </p>
                <p>
                  تم تطوير هذه الحاسبة لتسهيل عملية حساب الزيادة مع توضيح خطوات
                  الحل لضمان الفهم الكامل.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="salary">
                      <label className="form-label ms-2" htmlFor="percentage">
                        أدخل الراتب الأساسي
                      </label>
                      <input
                        id="salary"
                        type="number"
                        value={salary}
                        onChange={(e) => setSalary(e.target.value)}
                        placeholder="أدخل الراتب الأساسي"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        أدخل النسبة المئوية للزيادة (%)
                      </label>
                      <input
                        id="percentage"
                        type="number"
                        value={percentage}
                        onChange={(e) => setPercentage(e.target.value)}
                        placeholder="أدخل النسبة المئوية"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <>
                      <div className="p-3 mb-2 bg-success">
                        <h4 className="text-white">النتيجة: {result} </h4>
                      </div>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <p className="text-black">
                          <strong>الخطوات:</strong>
                        </p>
                        <ul className="p-3 mb-2 bg-info text-black">
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هي الزيادة في الراتب؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      مفهوم الزيادة في الراتب
                    </h2>
                  </u>
                  <p>
                    الزيادة في الراتب هي مبلغ إضافي يحصل عليه الموظف كجزء من
                    راتبه الشهري. هذه الزيادة تكون عادةً نسبة مئوية من الراتب
                    الأساسي للموظف، وتضاف إلى الراتب بعد حسابها. يمكن أن تكون
                    هذه الزيادة نتيجة لأداء ممتاز، أو زيادة تكلفة المعيشة، أو أي
                    سبب آخر تقرره الإدارة.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كان راتبك الأساسي هو 4000 ريال وتم تحديد زيادة
                    بنسبة 5%، فإن الزيادة تساوي: 4000 × 0.05 = 200 ريال
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيفية حساب الزيادة</h2>
                  </u>
                  <p>لحساب الزيادة في الراتب، اتبع الخطوات التالية:</p>
                  <ul>
                    <li>أدخل الراتب الأساسي في الصيغة المناسبة.</li>
                    <li>أدخل النسبة المئوية للزيادة.</li>
                    <li>
                      اضرب الراتب الأساسي في النسبة المئوية للحصول على قيمة
                      الزيادة.
                    </li>
                    <li>
                      أضف قيمة الزيادة إلى الراتب الأساسي للحصول على الراتب
                      الجديد.
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كان راتبك الأساسي هو 5000 ريال وكانت الزيادة 8%،
                    فإن الزيادة تساوي: 5000 × 0.08 = 400 ريال
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>
                  </u>
                  <p>
                    إجابات لبعض الأسئلة الشائعة حول الزيادة في الراتب وحسابها.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    سؤال: لماذا يتم تحديد الزيادة كنسبة مئوية؟
                    <br />
                    جواب: تحديد الزيادة كنسبة مئوية يسمح بتكييف المبلغ المضاف
                    بناءً على حجم الراتب الأساسي، مما يضمن أن تكون الزيادة عادلة
                    بالنسبة لجميع الموظفين.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default SalaryBonusCalculator;
